import { render, staticRenderFns } from "./labelItem.vue?vue&type=template&id=1c370bba&scoped=true"
import script from "./labelItem.vue?vue&type=script&lang=js"
export * from "./labelItem.vue?vue&type=script&lang=js"
import style0 from "./labelItem.vue?vue&type=style&index=0&id=1c370bba&prod&lang=scss&scoped=true"
import style1 from "./labelItem.vue?vue&type=style&index=1&id=1c370bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c370bba",
  null
  
)

export default component.exports